export const windowsCatalogDefinitionId = ['AZWINVM', 'AZWINVM2016', 'AZWINVM2019', 'AZWINVM2022', 'AZWINVM2025'];
export const linuxCatalogDefinitionId = ['AZRHELVM', 'AZRHEL8LVM', 'AZRHEL7LVM', 'AZRHEL8VM', 'AZRHEL7VM', 'AZOEL7VM', 'AZSLES15VM', 'AZSLES12VM', 'AZOEL8VM'];
export const linuxRHEL8CatalogDefinitionId = ['AZRHEL8LVM', 'AZRHEL8VM'];
export const linuxSLESCatalogDefinitionId = ['AZSLES15VM', 'AZSLES12VM'];
export const linuxOELCatalogDefinitionId = ['AZOEL7VM', 'AZOEL8VM'];
export const kafkaCatalogDefinitionId = ['AZKAFKA', 'CFKAFKA'];
export const AlbCatalogDefinitionId = ['AZLOADBAL'];
export const keyvaultCatalogDefinitionId = ['AZKEYVAULT'];
export const nsgCatalogDefinitionId = ['NSGAS'];
export const eventhubDefinitionId = ['AZEVENTHUB'];
export const pECatalogDefinitionId = ['AZUREPE'];
export const oracleIaaSDefinitionId = ['AZRHELORA19C', 'AZOELORA19C'];
export const oelOracleCatalogDefinitionId = ['AZOELORA19C'];
export const sqlIaaSCatalogDefinitionId = ['AZWINSQLIAAS2019', 'AZWINSQLIAAS'];
export const pgcsSqlIaaSCatalogDefinitionId = ['PGCSWINSQLIAAS'];
export const pgcsWindowsVmCatalogDefinitionId = ['PGCSWINVM2022'];
export const storageCatalogDefinitionId = ['AZSTORAGE'];
export const eipStackCatalogDefinitionId = ['CMPAPPMICROSERVICE'];
export const sqlPaaSCatalogDefinitionId = ['AZSQLPAAS'];
export const aksCatalogDefinitionId = ['AZAKSNS'];
export const adfCatalogDefinitionId = ['AZDATAFACTORY'];
export const couchbaseDbDefinitionId = ['COUCHBASEDB'];
export const RICatalogDefinitionId = [
    'RI001',
    'RI002',
    'RI003',
    'RI003O',
    'RI003AWS',
    'RI003A',
    'RI004',
    'RIIOTEVENTHUB',
    'RI004A',
    'RI005',
    'RI001A',
    'RICONSUMERAPP',
];
export const Day2CatalogDefinitionId = ['DAY2ADDMEMBERS'];
export const ServiceAccountDefinitionId = ['DAY2SERVICEACCOUNT'];
export const SecurityToolCatalogDefinitionId = ['DAY2SECURITYTOOLONBOARD'];
export const OnBoardDevelopersCatalogDefinitionId = ['DAY2DEVELOPERONBOARD'];
export const SsoOktaCatalogDefinitionId = ['DAY2ADDSSOOKTA'];
export const SsoOktaModifyCatalogDefinitionId = ['DAY2MODIFYSSOOKTA'];
export const ApplicationGateWayURLCatalogDefinitionID = ['AZAGWURLONBOARD'];
export const InternalApplicationGateWayURLCatalogDefinitionID = ['AZINTAGWURLONBOARD'];
export const ExternalPublicLoadBalancerURLCatalogDefinitionID = ['AZPLBURLONBOARD'];
export const MdtCatalogDefinitionId = ['DAY2MDTONBOARD'];
export const ProjectOnboardCatalogDefinitionId = ['DAY2ADOONBOARD'];
export const GithubOnboardingCatalogDefinitionId = ['DAY2GITHUBONBOARD'];
export const VirtualServiceCatalogDefinitionId = ['AZAKSVIRTUALSERVICE'];
export const SlesPgtCatalogDefinitionId = ['AZPGTSAPSLES15VM'];
export const PgtSapSolutionCatalogDefinitionId = ['AZUREPGTSAPSLESVM'];
export const SlesPgtDBCatalogDefinitionId = ['AZPGTSAPSLESHANADB'];
export const NewInternalApplicationGateWayProvisioningCatalogDefinitionID = ['AZNEWINTAPPGW'];
export const DevSecOpsCatalogDefinitionID = ['AZUREDEVSECOPS'];
export const NsgAutomationRulesProvisioningCatalogDefinitionID = ['AZAPPNSGRULES'];
export const CloudOnboardingCatalogDefinitionID = ['CLOUDONBOARD'];
export const JFrogCatalogDefinitionId = ['DAY2JFROGONBOARD'];
export const DSCloningCatalogDefinitionId = ['DAY2ADOTEAMSMEMBERSHIP'];
export const AwsEC2CatalogDefinitionId = ['AWSWINVM2022', 'AWSWINVM2019', 'AWSWINVM2025'];
export const AwsRHELCatalogDefinitionId = ['AWSRHELVM'];
export const AwsRHELCBCatalogDefinitionId = ['AWSRHELCBVM'];
export const AwsSLESCatalogDefinitionId = ['AWSSLESVM'];
export const edapAksCatalogDefinitionId = ['AZEDAPAKSNS'];
export const AwsOracleRDSCatalogDefinitionId = ['AWSORACLERDSINSTANCE'];
export const AwsSQLRDSCatalogDefinitionId = ['AWSSQLRDSINSTANCE'];
export const AwsS3BucketCatalogDefinitionId = ['AWSS3BUCKET'];
export const AwsOELCatalogDefinitionId = ['AWSOELVM'];
export const AwsPostgresqlCatalogDefinitionId = ['AWSPOSTGRESQLRDSINSTANCE'];
export const AwsOracle19CCatalogDefinitionId = ['AWSOELORA19C'];
export const AwsSQLIaasCatalogDefinitionId = ['AWSWINSQLIAAS'];
export const AwsDynamoDbCatalogDefinitionId = ['AWSDYNAMODBINSTANCE'];
export const AwsEksnCatalogDefinitionId = ['AWSEKSNS'];
export const AwsALBCatalogDefinitionId = ['AWSALB'];
export const AwsNLBCatalogDefinitionId = ['AWSNLBINSTANCE'];
export const AwsExternalNLBCatalogDefinitionId = ['AWSEXTNLBINSTANCE'];
export const PostgreSQLFlexibleDbCatalogDefinitionId = ['AZPOSTGRESQLINSTANCE'];
export const MySQLFlexibleDbCatalogDefinitionId = ['AZMYSQLINSTANCE'];
export const AwsCloudOnboardingCatalogDefinitionId = ['AWSCLOUDONBOARD'];
export const AwsAccountVendingCatalogDefinitionId = ['AWSACCOUNTONBOARD'];
export const AwsInternalUrlOnboardingCatalogDefinitionId = ['AWSINTERNALURLONBOARD'];
export const AwsExternalURLOnboardingCatalogDefinitionId = ['AWSEXTERNALURLONBOARD'];
export const CosmosDbCatalogDefinitionId = ['AZCOSMOSDB'];
export const AwsLexCatalogDefinitionId = ['AWSLEXBOT'];
export const AwsMYSQLRDSCatalogDefinitionId = ['AWSMYSQLRDSINSTANCE'];
export const AwsSNSCatalogDefinitionId = ['AWSSNSTOPIC'];
export const AwsKafkaTopicCatalogDefinitionId = ['AWSCFKAFKA'];
export const PCWindowsCatalogDefinitionId = ['NUTANICWINVM'];
export const AwsLambdaFunctionCatalogDefinitionId = ['AWSLAMBDAINSTANCE'];
export const PCLinuxCatalogDefinitionId = ['NUTANICSLINUXVM'];
export const PCSQLIaasCatalogDefinitionId = ['NUTANIXSQLDB'];
export const PCOracleDBCatalogDefinitionId = ['NUTANIXOELDB'];
export const EDAPAzureNodePoolCatalogDefinitionId = ['AZEDAPNP'];
export const AzCBVMCatalogDefinitionId = ['AZCBVM'];
export const AwsSQSCatalogDefinitionId = ['AWSSQS'];
export const AzureOracleExadataCatalogDefinitionId = ['AZORACLEEXADATADB'];
export const AwsDocumentDBCatalogDefinitionId = ['AWSDOCUMENTDB'];
